export default __webpack_public_path__ + "static/media/map_pin_ferdigbehandlet_alvorlig_avvik_fra_kontrollør.a1ef4b39.svg";